import React, { useState } from 'react'
import Creatable from '../Creatable'

const ZipExceptions = props => {
    const [inputVal, setInputVal] = useState("")
    const [error, setError] = useState({ isErr: false, msg: null })
    return (
        <div className='rule__values'>
            <Creatable
                esteric={false}
                range={false}
                isDisabled={!props.isSelected}
                inputValue={inputVal}
                setInputValue={setInputVal}
                label={"ZipCodes"}
                id="exp_zip_codes"
                placeholder={`Add ZipCodes`}
                defaults={props.exp_zip_codes}
                handleChange={props.handleChange}
                value={props.exp_zip_codes}
                error={error}
                err={null}
                valuesAllowed={5}
                setError={setError}
            />
        </div>
    )
}

export default ZipExceptions
